export default "__VITE_ASSET__C$ecy6L4__"